/**
 * The dropdown that fills a signature block from a ready variant.
 *
 * Its own file rather than fifteen more lines inside `BlockFields.tsx`, which
 * is already a long switch: this control has behaviour of its own (it derives
 * its value, and one of its options is not a value) and that is the part worth
 * being able to find.
 *
 * Choosing "custom" does nothing on purpose. It is there so the dropdown can
 * say what the block IS after somebody edited a field by hand; a select that
 * renders blank in that state reads as broken.
 */
import { useT } from "../../i18n/I18nProvider";
import { ChoiceField } from "./controls";
import { CUSTOM_SIGNATURE_ID, findSignature, matchSignature, SIGNATURES } from "../signatures";

export function SignaturePicker({
  props,
  onApply,
}: {
  props: Record<string, unknown>;
  onApply: (fields: Record<string, unknown>) => void;
}) {
  const t = useT();
  const current = matchSignature(props);

  const options = [
    ...SIGNATURES.map((s) => ({ value: s.id, label: t(`marketing.builder.signature.variant.${s.key}`) })),
    ...(current === CUSTOM_SIGNATURE_ID
      ? [{ value: CUSTOM_SIGNATURE_ID, label: t("marketing.builder.signature.custom") }]
      : []),
  ];

  return (
    <ChoiceField
      label={t("marketing.builder.signature.pick")}
      hint={t("marketing.builder.signature.hint")}
      value={current}
      options={options}
      onChange={(id) => {
        const variant = findSignature(id);
        // The avatar is deliberately not in `fields`, so it survives.
        if (variant) onApply({ ...variant.fields });
      }}
    />
  );
}
